import { lazy } from 'react';
import type { TransparencyReportingAuthorization } from 'src/apis/transparency-reporting/types';
import {
  JOB_SEARCH_URL,
  useJobSearch,
} from 'src/apis/transparency-reporting/use-job-search';
import { useJobsPageParams } from 'src/pages/reporting/transparency-reporting/jobs/overview/use-page-params';

const Page = lazy(() => import('./page'));

type Props = {
  authorization: TransparencyReportingAuthorization;
};

export const JobsOverview = ({ authorization }: Props) => {
  const pageParams = useJobsPageParams();
  const search = useJobSearch({
    jobSearchUrl: JOB_SEARCH_URL,
    params: pageParams.value,
  });

  return (
    <Page
      authorization={authorization}
      pageParams={pageParams}
      search={search}
    />
  );
};
